import React, { Component } from "react";
import { Button } from "react-bootstrap";
import "./SettingsItem.scss";

class SettingsItem extends Component {
  render() {
    const {
      title,
      value,
      buttonTitle,
      horizontal
    } = this.props;

    return (
      <div className="settings-item d-flex justify-content-between align-items-end">
        {horizontal && <div className="title">{title}</div>}
        {horizontal && <div className="value">{value}</div>}
        {!horizontal &&
          <div className="info" >
            <div className="title">{title}</div>
            <div className="value">{value}</div>
          </div>
        }
        {buttonTitle && <Button variant="outline-danger" size="sm" onClick={this.props.onClick}>{buttonTitle}</Button>}
      </div>
    );
  }
}

export default SettingsItem;
